import enUS from './en-us';
import frFR from './fr-fr';

export default {
  'en-us': enUS,
  'fr-fr': frFR,
};
